import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPlayground: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPlayground"><Path d="M14.0098 13.3153C11.8866 13.3153 10.1641 15.0348 10.1641 17.1576C10.1641 19.2804 11.8866 20.9999 14.0098 20.9999C16.1329 20.9999 17.8555 19.2804 17.8555 17.1576C17.8555 15.0348 16.1329 13.3153 14.0098 13.3153Z" fill="currentColor"/><Path d="M13.7411 2.58167L11.75 10.0043L19.1795 11.9929L21.1705 4.57019L13.7411 2.58167Z" fill="currentColor"/><Path d="M4.47801 5.57739L2.78516 15.1675L11.946 11.8369L4.47801 5.57739Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPlayground;
